up.compiler('form[with-client-validations]', (element) => {

  element.addEventListener('submit', function(_event) {
    const invalidFields = element.querySelectorAll('.is-invalid')
    const invalidFeedback = element.querySelectorAll('.invalid-feedback')

    invalidFields.forEach((field) => {
      field.classList.remove('is-invalid')
      field.removeAttribute('data-invalid-feedback')
    })

    invalidFeedback.forEach((feedback) => feedback.remove())
  }, { capture: true }) // run during capture phase so we reset old errors before other submit handlers validate
})
